import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useAccess } from './access/AccessProvider';
import { LoadingSpinner } from './common/LoadingSpinner';
import { useNavigation } from '../hooks/useNavigation';
import { SidebarContent } from './SidebarContent';
import { SidebarWrapper } from './SidebarWrapper';

interface SidebarProps {
  isMobileMenuOpen: boolean;
  setIsMobileMenuOpen: (isOpen: boolean) => void;
  isSidebarCollapsed: boolean;
}

export default function Sidebar({
  isMobileMenuOpen,
  setIsMobileMenuOpen,
  isSidebarCollapsed,
}: SidebarProps) {
  const location = useLocation();
  const { access, isLoading: isAccessLoading } = useAccess();

  const [currentSubmenu, setCurrentSubmenu] = useState<string | null>(null);
  const [manuallyClosedOracleSubmenu, setManuallyClosedOracleSubmenu] = useState<boolean>(false);

  // Get navigation items for the selected platform
  const navigation = useNavigation();

  // Close mobile menu on navigation
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname, setIsMobileMenuOpen]);

  // Show Oracle submenu when on Oracle pages, hide when not
  useEffect(() => {
    if (location.pathname.startsWith('/oracle')) {
      // Only show Oracle submenu if it wasn't manually closed
      if (!manuallyClosedOracleSubmenu) {
        setCurrentSubmenu('oracle');
      }
    } else {
      // Reset manual close flag when leaving Oracle
      setManuallyClosedOracleSubmenu(false);
      setCurrentSubmenu(null);
    }
  }, [location.pathname, manuallyClosedOracleSubmenu]);

  if (isAccessLoading || access == null) {
    return <LoadingSpinner />;
  }

  return (
    <>
      {/* Mobile menu overlay */}
      {isMobileMenuOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-gray-600 bg-opacity-75 z-40"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      {/* Sidebar - always fixed, animated with transforms */}
      <SidebarWrapper isMobileMenuOpen={isMobileMenuOpen} isSidebarCollapsed={isSidebarCollapsed}>
        {/* Main navigation */}
        <SidebarContent
          navigation={navigation}
          currentSubmenu={currentSubmenu}
          onOracleClick={() => setCurrentSubmenu('oracle')}
          onBackClick={() => {
            setCurrentSubmenu(null);
            setManuallyClosedOracleSubmenu(true);
          }}
        />

        {/* Bottom section */}
        <div className="pt-3">{/* No upgrade banner in developer platform */}</div>
      </SidebarWrapper>
    </>
  );
}
